export enum FunctionCategory {
  DeliveryNote = 1,
  CreditReport = 2,
  ElectronicInvoice = 3,
  Reminder = 4,
}

/**
 * Normalizes a category value coming from the API (numeric enum or string name, e.g.
 * "ElectronicInvoice") or from an i18n key into the {@link FunctionCategory} enum, or null if
 * unrecognized.
 */
export function normalizeFunctionCategory(value: FunctionCategory | string | null | undefined): FunctionCategory | null {
  if (value == null || value === '') {
    return null;
  }

  if (typeof value === 'number') {
    return value;
  }

  const numericValue = Number(value);
  if (!Number.isNaN(numericValue)) {
    return numericValue as FunctionCategory;
  }

  const byName = FunctionCategory[value as keyof typeof FunctionCategory];
  if (byName) {
    return byName;
  }

  switch (value.toLowerCase()) {
    case 'deliverynote':
      return FunctionCategory.DeliveryNote;
    case 'creditreport':
      return FunctionCategory.CreditReport;
    case 'electronicinvoice':
      return FunctionCategory.ElectronicInvoice;
    case 'reminder':
      return FunctionCategory.Reminder;
    default:
      return null;
  }
}
